@if (atgardMbf) {
  <div class="container-fluid ps-0">
    <div class="row">
      <div class="col-md-12">
        <rask-header size="4">Markberedning</rask-header>
        <rask-markberedningsmetod [atgardMbf]="atgardMbf" [readonly]="kontraktReadonly || atgard.isUtfort">
        </rask-markberedningsmetod>
      </div>
    </div>
    <div class="row mt-3">
      <div class="separator">
        <div class="col-md-12">
          <rask-header size="4">Föryngringsåtgärd</rask-header>
          <rask-foryngringsatgard [atgardMbf]="atgardMbf" [readonly]="kontraktReadonly || atgard.isUtfort">
          </rask-foryngringsatgard>
        </div>
      </div>
    </div>
  </div>
}
